import { competitionListTimeEnum } from "app/utils/const";

const NoRunnersElement = ({ line }: { line: string }) => (
  <div className="asian-marketType-outer-container__onextwo">
    <div
      className={`asian-marketType-container__onextwo--empty ${
        line === competitionListTimeEnum.ALL ? "all-view" : ""
      }`}
    ></div>
  </div>
);

export default NoRunnersElement;
